/*
 * recommended-product (schema)
 */
import { boolean, doublePrecision, timestamp, uuid } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"
import { patients } from "../patient/patient.schema"
import { treatments } from "../treatment/treatment.schema"
import { products } from "../product/product.schema"

export const recommendedProducts = schema.table("recommended_products", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	treatmentId: uuid("treatment_id")
		.notNull()
		.references(() => treatments.id, { onDelete: "cascade" }),
	productId: uuid("product_id")
		.notNull()
		.references(() => products.id, { onDelete: "cascade" }),
	patientId: uuid("patient_id")
		.notNull()
		.references(() => patients.id, { onDelete: "cascade" }),

	// --- General ---
	amount: doublePrecision("amount").notNull(),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
